/**
 * 404 Not Found Page
 */

import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Logo } from '../components/common/Logo';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      {/* Hide navigation on 404 page */}
      <style>{`
        nav {
          display: none !important;
        }
      `}</style>

      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--color-gray-50)',
        padding: '2rem'
      }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{ textAlign: 'center' }}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            style={{
              marginBottom: '2rem',
              display: 'inline-block',
              padding: '1.5rem 1rem',
              paddingTop: '2.7rem',
              borderRadius: '50%',
              backgroundColor: '#434242'
            }}
          >
            <Logo variant="hero" />
          </motion.div>

          <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          style={{
            fontSize: 'clamp(4rem, 15vw, 10rem)',
            fontWeight: 800,
            lineHeight: 1,
            marginBottom: '1rem',
            background: 'linear-gradient(135deg, var(--color-lime-500) 0%, var(--color-lime-600) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          404
        </motion.h1>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          style={{
            fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
            fontWeight: 700,
            color: 'var(--color-gray-800)',
            marginBottom: '1rem'
          }}
        >
          Erro 404
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          style={{
            fontSize: '1.25rem',
            color: 'var(--color-gray-600)',
            marginBottom: '3rem'
          }}
        >
          Esta página não existe
        </motion.p>

        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          onClick={() => navigate('/')}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="button btn-magreen btn-large"
          style={{
            padding: '1rem 2.5rem',
            fontSize: '1.1rem'
          }}
        >
          Voltar para o Início
        </motion.button>
        </motion.div>
      </div>
    </>
  );
}
